import React from 'react';

import * as S from './styles';

const Home: React.FC = () => {
  return <S.Container />;
};

export { Home };
